module.exports = __webpack_public_path__ + "img/Humanisme_Tida-og-samfunnsforholdene2.c6fe303c.jpg";